/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Agent_Run_Action_Not_TakenInputs */



/**
* | output |
* | --- |
* | "{action}: not taken" |
*
* @param {Agent_Run_Action_Not_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_action_not_taken = /** @type {((inputs: Agent_Run_Action_Not_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Action_Not_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.action}: nicht ausgeführt`)
	return /** @type {LocalizedString} */ (`${i?.action}: not taken`)
});